module.exports = __webpack_public_path__ + "static/media/anti-corruption-plans-2nd-half-of-2021.dd2e4433.pdf";